<template>
  <div class="presentation-owner">
    <aha-avatar
      v-if="ownerAvatar || ownerName"
      :name="ownerName"
      :image="ownerAvatar"
      :id="ownerId"
      class="mr-1 flex-shrink-0"
    />
    <div class="presentation-owner__name">
      {{ ownerName }}
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import EmailUtils from '@/utils/email'
import ahaSystem from '@/constant/ahaSystem'
import MultiSessionApi from '@/api/multipleSession'

export default {
  props: {
    data: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      owner: null, // this state is to detect the 'true' owner of the presentation that share with multiple presenters
    }
  },

  computed: {
    ...mapGetters('multipleSessions', ['canUseShareDocs']),
    ownerAvatar() {
      if (this.isPresenterBeingSharedByEditor && this.owner) {
        return this.owner?.avatar
      }
      if (this.data.User && this.data?.User?.email !== ahaSystem.email) {
        return this.data.User?.avatar
      }
      return null
    },
    ownerId() {
      return this.data.User.id
    },
    isPresenterBeingSharedByEditor() {
      return this.canUseShareDocs && this.data?.User?.email === ahaSystem.email
    },
    ownerName() {
      if (this.isPresenterBeingSharedByEditor && this.owner) {
        return `${this.owner?.firstName} ${this.owner?.lastName}`
      }
      if (this.data.User && this.data?.User?.email !== ahaSystem.email) {
        if (this.data.User.firstName) {
          return `${this.data.User.firstName} ${this.data.User.lastName}`
        }
        if (this.data.User.email) {
          return EmailUtils.getEmailName(this.data.User.email)
        }
      }

      return null
    },
  },
  watch: {
    isPresenterBeingSharedByEditor(isPresenterBeingSharedByEditor) {
      if (isPresenterBeingSharedByEditor) {
        this.getOwner()
      }
    },
  },

  async mounted() {
    if (this.isPresenterBeingSharedByEditor) {
      await this.getOwner()
    }
  },

  methods: {
    async getOwner() {
      try {
        const resp = await MultiSessionApi.getPresentationMasterByPresentationId(this.data.id, true)
        this.owner = resp?.body?.rootPresentation?.User
      } catch (error) {
        console.error('Failed to get the owner of the presentation', error)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.presentation-owner {
  @apply flex flex-row items-center;
}
.presentation-owner__avatar {
  @apply rounded-full flex items-center justify-center mr-1;
  @apply text-base-0 uppercase;
  .__image {
    @apply rounded-full border border-primary-80;
  }
  width: 28px;
  height: 28px;
}
.presentation-owner__name {
  @apply capitalize truncate max-w-24 xl:max-w-40 text-xs;
}
</style>>
